export default "__VITE_ASSET__BjG0XywX__"